import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];

    const run = async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: res.data }, replace: true });
      } catch (e) {
        navigate("/admin/login", { replace: true });
      }
    };
    if (sessionId) run();
    else navigate("/admin/login", { replace: true });
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-heirloom-emerald text-heirloom-bone">
      <p className="font-display text-2xl tracking-wide">Entering the celebration…</p>
    </div>
  );
}
